module.exports = __webpack_public_path__ + "fonts/onprem_ico@2x.5689196f5a992b29b44140c0abe64eb3.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/onprem_ico@2x.png
// module id = 771
// module chunks = 9